import React, { useEffect, useState } from 'react';
import './hero.scss';
import { StaticImage } from 'gatsby-plugin-image';
// @ts-ignore
import KoktailLogo from '../../assets/images/koktail-logo-transparant.svg';

type HeroProps = {
  children?: React.ReactChild
  size: 'small' | 'normal'
}
const Hero = ({ size }: HeroProps) => {
  const storageKey = 'subscribed';
  const [subscribed, setSubscribed] = useState<string | null>(null);
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState<undefined | null | string>(undefined);

  useEffect(() => {
    if (localStorage.getItem(storageKey)) {
      setSubscribed(localStorage.getItem(storageKey));
    }
  }, []);

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmailError(null);
    setEmail(e.target.value);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (validateEmail(email)) {
      const url = 'https://api.urbanjungle.care/api/users';

      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: email
          }),
        });

        if (res.status === 201) {
          localStorage.setItem(storageKey, email);
          setSubscribed(email);
        } else {
          localStorage.setItem(storageKey, email);
          setSubscribed(email);
        }
      } catch (error) {
        console.error('Error:', error);
      }
    } else {
      setEmailError('Not a valid email address');
    }
  };

  const validateEmail = (email: string) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  return (
    <div className={ `hero-container hero-container--${ size }` }>
      <div className={ `hero hero--${ size }` }>
        <div className="hero-image">
          <StaticImage
            placeholder="blurred"
            quality={ 90 }
            src="../../assets/images/hero.png"
            alt="urban jungle hero"
          />
        </div>
        <div className="hero-text">
          <h2>Keep your urban jungle healthy and thriving.</h2>
          <p>We're excited to offer you an exclusive alpha access to our upcoming mobile app, which will put
            tropical plant care literally at your fingertips.</p>
          {
            subscribed ?
              <div className="subscribe">
                <p>
                  You have now alpha access with: <b>{ subscribed }</b><br/>
                  We'll let you know as soon as the alpha release is available.
                </p>
              </div>
              :
              <div className="subscribe">
                <div>
                  <label className="label">
                    Subscribe for the upcoming alpha release:
                  </label>
                  <div>
                    <form onSubmit={ handleSubmit }>
                      <input onChange={ handleEmailChange } className={ emailError ? 'input input-error' : 'input' }
                             placeholder="Your email address"/>
                      <button type="submit" className="button button--primary">
                        <span>Subscribe</span>
                      </button>
                    </form>
                    { emailError && <label className="error-message">{ emailError }</label> }
                  </div>
                </div>
              </div>
          }

          <div className="by">
            <span>Developed by:</span>
            <a href="https://www.koktail.nl" target="_blank">
              <div className="logo">
                <KoktailLogo/>
              </div>
            </a>
          </div>

        </div>
      </div>
    </div>
  );
};
export default Hero;
